export const RANGE_INPUT_DEFAULT_STEP = 1;
export const RANGE_INPUT_DEFAULT_MIN = 0;
export const RANGE_INPUT_DEFAULT_MAX = 20;
